export default __webpack_public_path__ + "static/media/services_municipal_2.71fb36ad.jpg";